package ui.theme

import androidx.compose.ui.graphics.Color

val primaryLight = Color(0xFF466730)
val onPrimaryLight = Color(0xFFFFFFFF)
val primaryContainerLight = Color(0xFFC7EEA9)
val onPrimaryContainerLight = Color(0xFF2F4F1B)
val secondaryLight = Color(0xFF56624B)
val onSecondaryLight = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFFD9E7CA)
val onSecondaryContainerLight = Color(0xFF3E4A35)
val tertiaryLight = Color(0xFF386665)
val onTertiaryLight = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0xFFBBECEB)
val onTertiaryContainerLight = Color(0xFF1E4E4E)
val errorLight = Color(0xFFBA1A1A)
val onErrorLight = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFFFDAD6)
val onErrorContainerLight = Color(0xFF93000A)
val backgroundLight = Color(0xFFF8FAF0)
val onBackgroundLight = Color(0xFF191D16)
val surfaceLight = Color(0xFFF8FAF0)
val onSurfaceLight = Color(0xFF191D16)
val surfaceVariantLight = Color(0xFFE0E4D6)
val onSurfaceVariantLight = Color(0xFF43483E)
val outlineLight = Color(0xFF74796D)
val outlineVariantLight = Color(0xFFC4C8BB)
val scrimLight = Color(0xFF000000)
val inverseSurfaceLight = Color(0xFF2E312A)
val inverseOnSurfaceLight = Color(0xFFF0F2E7)
val inversePrimaryLight = Color(0xFFACD28F)
val surfaceDimLight = Color(0xFFD9DBD1)
val surfaceBrightLight = Color(0xFFF8FAF0)
val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFF3F5EA)
val surfaceContainerLight = Color(0xFFEDEFE4)
val surfaceContainerHighLight = Color(0xFFE7E9DF)
val surfaceContainerHighestLight = Color(0xFFE1E4D9)

val primaryLightMediumContrast = Color(0xFF1F3D0B)
val onPrimaryLightMediumContrast = Color(0xFFFFFFFF)
val primaryContainerLightMediumContrast = Color(0xFF54763D)
val onPrimaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val secondaryLightMediumContrast = Color(0xFF2E3A25)
val onSecondaryLightMediumContrast = Color(0xFFFFFFFF)
val secondaryContainerLightMediumContrast = Color(0xFF647159)
val onSecondaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryLightMediumContrast = Color(0xFF073D3D)
val onTertiaryLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightMediumContrast = Color(0xFF477574)
val onTertiaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val errorLightMediumContrast = Color(0xFF740006)
val onErrorLightMediumContrast = Color(0xFFFFFFFF)
val errorContainerLightMediumContrast = Color(0xFFCF2C27)
val onErrorContainerLightMediumContrast = Color(0xFFFFFFFF)
val backgroundLightMediumContrast = Color(0xFFF8FAF0)
val onBackgroundLightMediumContrast = Color(0xFF191D16)
val surfaceLightMediumContrast = Color(0xFFF8FAF0)
val onSurfaceLightMediumContrast = Color(0xFF0F120C)
val surfaceVariantLightMediumContrast = Color(0xFFE0E4D6)
val onSurfaceVariantLightMediumContrast = Color(0xFF33382E)
val outlineLightMediumContrast = Color(0xFF4F5449)
val outlineVariantLightMediumContrast = Color(0xFF6A6F63)
val scrimLightMediumContrast = Color(0xFF000000)
val inverseSurfaceLightMediumContrast = Color(0xFF2E312A)
val inverseOnSurfaceLightMediumContrast = Color(0xFFF0F2E7)
val inversePrimaryLightMediumContrast = Color(0xFFACD28F)
val surfaceDimLightMediumContrast = Color(0xFFC5C8BD)
val surfaceBrightLightMediumContrast = Color(0xFFF8FAF0)
val surfaceContainerLowestLightMediumContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightMediumContrast = Color(0xFFF3F5EA)
val surfaceContainerLightMediumContrast = Color(0xFFE7E9DF)
val surfaceContainerHighLightMediumContrast = Color(0xFFDCDED3)
val surfaceContainerHighestLightMediumContrast = Color(0xFFD0D3C8)

val primaryLightHighContrast = Color(0xFF153302)
val onPrimaryLightHighContrast = Color(0xFFFFFFFF)
val primaryContainerLightHighContrast = Color(0xFF32511D)
val onPrimaryContainerLightHighContrast = Color(0xFFFFFFFF)
val secondaryLightHighContrast = Color(0xFF242F1C)
val onSecondaryLightHighContrast = Color(0xFFFFFFFF)
val secondaryContainerLightHighContrast = Color(0xFF414D37)
val onSecondaryContainerLightHighContrast = Color(0xFFFFFFFF)
val tertiaryLightHighContrast = Color(0xFF003232)
val onTertiaryLightHighContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightHighContrast = Color(0xFF215050)
val onTertiaryContainerLightHighContrast = Color(0xFFFFFFFF)
val errorLightHighContrast = Color(0xFF600004)
val onErrorLightHighContrast = Color(0xFFFFFFFF)
val errorContainerLightHighContrast = Color(0xFF98000A)
val onErrorContainerLightHighContrast = Color(0xFFFFFFFF)
val backgroundLightHighContrast = Color(0xFFF8FAF0)
val onBackgroundLightHighContrast = Color(0xFF191D16)
val surfaceLightHighContrast = Color(0xFFF8FAF0)
val onSurfaceLightHighContrast = Color(0xFF000000)
val surfaceVariantLightHighContrast = Color(0xFFE0E4D6)
val onSurfaceVariantLightHighContrast = Color(0xFF000000)
val outlineLightHighContrast = Color(0xFF292E24)
val outlineVariantLightHighContrast = Color(0xFF464B40)
val scrimLightHighContrast = Color(0xFF000000)
val inverseSurfaceLightHighContrast = Color(0xFF2E312A)
val inverseOnSurfaceLightHighContrast = Color(0xFFFFFFFF)
val inversePrimaryLightHighContrast = Color(0xFFACD28F)
val surfaceDimLightHighContrast = Color(0xFFB7BAB0)
val surfaceBrightLightHighContrast = Color(0xFFF8FAF0)
val surfaceContainerLowestLightHighContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightHighContrast = Color(0xFFF0F2E7)
val surfaceContainerLightHighContrast = Color(0xFFE1E4D9)
val surfaceContainerHighLightHighContrast = Color(0xFFD3D5CB)
val surfaceContainerHighestLightHighContrast = Color(0xFFC5C8BD)

val primaryDark = Color(0xFFACD28F)
val onPrimaryDark = Color(0xFF193705)
val primaryContainerDark = Color(0xFF2F4F1B)
val onPrimaryContainerDark = Color(0xFFC7EEA9)
val secondaryDark = Color(0xFFBDCBAF)
val onSecondaryDark = Color(0xFF283420)
val secondaryContainerDark = Color(0xFF3E4A35)
val onSecondaryContainerDark = Color(0xFFD9E7CA)
val tertiaryDark = Color(0xFFA0CFCE)
val onTertiaryDark = Color(0xFF003737)
val tertiaryContainerDark = Color(0xFF1E4E4E)
val onTertiaryContainerDark = Color(0xFFBBECEB)
val errorDark = Color(0xFFFFB4AB)
val onErrorDark = Color(0xFF690005)
val errorContainerDark = Color(0xFF93000A)
val onErrorContainerDark = Color(0xFFFFDAD6)
val backgroundDark = Color(0xFF11140E)
val onBackgroundDark = Color(0xFFE1E4D9)
val surfaceDark = Color(0xFF11140E)
val onSurfaceDark = Color(0xFFE1E4D9)
val surfaceVariantDark = Color(0xFF43483E)
val onSurfaceVariantDark = Color(0xFFC4C8BB)
val outlineDark = Color(0xFF8E9286)
val outlineVariantDark = Color(0xFF43483E)
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFE1E4D9)
val inverseOnSurfaceDark = Color(0xFF2E312A)
val inversePrimaryDark = Color(0xFF466730)
val surfaceDimDark = Color(0xFF11140E)
val surfaceBrightDark = Color(0xFF373A33)
val surfaceContainerLowestDark = Color(0xFF0C0F09)
val surfaceContainerLowDark = Color(0xFF191D16)
val surfaceContainerDark = Color(0xFF1D211A)
val surfaceContainerHighDark = Color(0xFF282B24)
val surfaceContainerHighestDark = Color(0xFF33362F)

val primaryDarkMediumContrast = Color(0xFFC1E8A3)
val onPrimaryDarkMediumContrast = Color(0xFF102C00)
val primaryContainerDarkMediumContrast = Color(0xFF779B5E)
val onPrimaryContainerDarkMediumContrast = Color(0xFF000000)
val secondaryDarkMediumContrast = Color(0xFFD3E1C4)
val onSecondaryDarkMediumContrast = Color(0xFF1E2916)
val secondaryContainerDarkMediumContrast = Color(0xFF88957B)
val onSecondaryContainerDarkMediumContrast = Color(0xFF000000)
val tertiaryDarkMediumContrast = Color(0xFFB5E5E4)
val onTertiaryDarkMediumContrast = Color(0xFF002B2B)
val tertiaryContainerDarkMediumContrast = Color(0xFF6B9998)
val onTertiaryContainerDarkMediumContrast = Color(0xFF000000)
val errorDarkMediumContrast = Color(0xFFFFD2CC)
val onErrorDarkMediumContrast = Color(0xFF540003)
val errorContainerDarkMediumContrast = Color(0xFFFF5449)
val onErrorContainerDarkMediumContrast = Color(0xFF000000)
val backgroundDarkMediumContrast = Color(0xFF11140E)
val onBackgroundDarkMediumContrast = Color(0xFFE1E4D9)
val surfaceDarkMediumContrast = Color(0xFF11140E)
val onSurfaceDarkMediumContrast = Color(0xFFFFFFFF)
val surfaceVariantDarkMediumContrast = Color(0xFF43483E)
val onSurfaceVariantDarkMediumContrast = Color(0xFFDADED0)
val outlineDarkMediumContrast = Color(0xFFAFB4A7)
val outlineVariantDarkMediumContrast = Color(0xFF8D9286)
val scrimDarkMediumContrast = Color(0xFF000000)
val inverseSurfaceDarkMediumContrast = Color(0xFFE1E4D9)
val inverseOnSurfaceDarkMediumContrast = Color(0xFF282B24)
val inversePrimaryDarkMediumContrast = Color(0xFF30501C)
val surfaceDimDarkMediumContrast = Color(0xFF11140E)
val surfaceBrightDarkMediumContrast = Color(0xFF42463E)
val surfaceContainerLowestDarkMediumContrast = Color(0xFF060804)
val surfaceContainerLowDarkMediumContrast = Color(0xFF1B1F18)
val surfaceContainerDarkMediumContrast = Color(0xFF262922)
val surfaceContainerHighDarkMediumContrast = Color(0xFF30342D)
val surfaceContainerHighestDarkMediumContrast = Color(0xFF3C3F37)

val primaryDarkHighContrast = Color(0xFFD4FCB5)
val onPrimaryDarkHighContrast = Color(0xFF000000)
val primaryContainerDarkHighContrast = Color(0xFFA8CE8B)
val onPrimaryContainerDarkHighContrast = Color(0xFF030E00)
val secondaryDarkHighContrast = Color(0xFFE7F5D7)
val onSecondaryDarkHighContrast = Color(0xFF000000)
val secondaryContainerDarkHighContrast = Color(0xFFB9C7AB)
val onSecondaryContainerDarkHighContrast = Color(0xFF050E02)
val tertiaryDarkHighContrast = Color(0xFFC9F9F8)
val onTertiaryDarkHighContrast = Color(0xFF000000)
val tertiaryContainerDarkHighContrast = Color(0xFF9CCBCB)
val onTertiaryContainerDarkHighContrast = Color(0xFF000E0E)
val errorDarkHighContrast = Color(0xFFFFECE9)
val onErrorDarkHighContrast = Color(0xFF000000)
val errorContainerDarkHighContrast = Color(0xFFFFAEA4)
val onErrorContainerDarkHighContrast = Color(0xFF220001)
val backgroundDarkHighContrast = Color(0xFF11140E)
val onBackgroundDarkHighContrast = Color(0xFFE1E4D9)
val surfaceDarkHighContrast = Color(0xFF11140E)
val onSurfaceDarkHighContrast = Color(0xFFFFFFFF)
val surfaceVariantDarkHighContrast = Color(0xFF43483E)
val onSurfaceVariantDarkHighContrast = Color(0xFFFFFFFF)
val outlineDarkHighContrast = Color(0xFFEDF2E3)
val outlineVariantDarkHighContrast = Color(0xFFC0C4B7)
val scrimDarkHighContrast = Color(0xFF000000)
val inverseSurfaceDarkHighContrast = Color(0xFFE1E4D9)
val inverseOnSurfaceDarkHighContrast = Color(0xFF000000)
val inversePrimaryDarkHighContrast = Color(0xFF30501C)
val surfaceDimDarkHighContrast = Color(0xFF11140E)
val surfaceBrightDarkHighContrast = Color(0xFF4E5149)
val surfaceContainerLowestDarkHighContrast = Color(0xFF000000)
val surfaceContainerLowDarkHighContrast = Color(0xFF1D211A)
val surfaceContainerDarkHighContrast = Color(0xFF2E312A)
val surfaceContainerHighDarkHighContrast = Color(0xFF393C35)
val surfaceContainerHighestDarkHighContrast = Color(0xFF454840)
